import CardContentProject from "components/Frontend/Card/CardContentProject";
import React from "react";

function Project() {
  return (
    <div className="details-header">
      <div className="container">
        <div className="row mt-4">
          <CardContentProject />
        </div>
      </div>
    </div>
  );
}

export default Project;
